import { useLabelVersion } from '../features/labels/LabelsProvider';
import { labelRegion } from '../features/labels/labels';
import React, { useState, useEffect, useMemo } from "react";
import { fetchConsolidadoService } from "../utils/apiServer";
import "./utils/css/HomeMap.css";
import ChileMap from "./utils/map/ChileMap";
import PeruMap from "./utils/map/PeruMap";
import FonchiMap from "./utils/map/FonchiMap";
import PanelPrincipal from "./utils/PanelPrincipal";
import PanelAreas from "./utils/PanelAreas";

import { Button, Modal ,Typography } from "@mui/material"
import Enviro from '../assets/img/APP enviro.png';
import Nanoox from '../assets/img/APP-nanoox-1 (003).png';
import NanooxBolt from '../assets/img/APP-nanoox-Bolt.png';
import Pss from '../assets/img/APP pss.png';
import Scapp from '../assets/img/APP-scapp.png';
import Construccion from '../assets/img/construccion.png'

const CHILE_GEOJSON =
  "https://cdn.jsdelivr.net/gh/caracena/chile-geojson@master/regiones.json";
const PERU_GEOJSON =
  "https://raw.githubusercontent.com/juaneladio/peru-geojson/master/peru_departamental_simple.geojson";

// Mapeo geojson → ID
const chileRegionMap = { 14:"losrios", 10: "loslagos", 11: "aysen", 12:'magallanes' };


// Mapping service keys to their icons
const serviceIcons = {
  enviro: Enviro,
  nanoox: Nanoox,
  flux:NanooxBolt,
  pss: Pss,
  scapp: Scapp,
};

function parseRegion(geo) {
  return (
    (geo.properties?.Region || geo.properties?.region || "")
      .replace(/^Región\s+(de|del)\s+/i, "")
  );
}

function capitalize(value) {
  if (!value) return '';

  // Divide la cadena en palabras
  let words = value.toLowerCase().split(' ');

  // Capitaliza la primera letra de cada palabra y divide 'Los' y 'Puerto' si están dentro de una palabra más grande
  let capitalizedWords = words.map(word => {
    // Reemplaza 'Los' y 'Puerto' en cualquier posición dentro de una palabra
    word = word.replace(/los/gi, 'Los ').replace(/puerto/gi, 'Puerto ').replace(/itg/gi, 'ITG');

    // Capitaliza la primera letra de cada palabra resultante
    return word.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  });

  // Une las palabras nuevamente en una cadena
  let capitalized = capitalizedWords.join(' ');

  return capitalized.trim(); // Remover cualquier espacio adicional accidental
}


export default function Home({ servidor, cargo, translate, SWVersion }) {
  useLabelVersion();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const [serviciosCentro , setServiciosCentro ] = useState({});
  const [chileGeo, setChileGeo] = useState(null);
  const [peruGeo, setPeruGeo] = useState(null);

  const [selRegion, setSelRegion] = useState(null);

  const [selArea, setSelArea] = useState(null);
  
  // NUEVO: lista de servicios y selección
  const serviceList = useMemo(() => Object.keys(serviceIcons), []);
  const [servicioFiltrado, setServicioFiltrado] = useState(null);
  const [centroSeleccionado, setCentroSeleccionado] = useState(null);

  const estados = useMemo(() => {
    const next = { regiones: {}, areas: {}, centros: {} };

    Object.entries(serviciosCentro || {}).forEach(([areaKey, centrosDeArea]) => {
      const [regionRaw = "", areaRaw = ""] = areaKey.split("-");
      const region = regionRaw.toLowerCase();
      const area = areaRaw.toLowerCase();
      const normalizedAreaKey = `${region}-${area}`;

      if (!region || !area) return;

      next.regiones[region] = true;
      next.areas[normalizedAreaKey] = true;
      next.centros[normalizedAreaKey] = {};

      Object.entries(centrosDeArea || {}).forEach(([centroKey, servicios]) => {
        next.centros[normalizedAreaKey][centroKey] = servicios;
      });
    });

    return next;
  }, [serviciosCentro]);

  // 1) Calculamos la lista plana de servicios
  const servicios = useMemo(() => {
    if (!estados.centros || typeof estados.centros !== "object") {
      return [];
    }
    const lista = [];
    Object.entries(estados.centros).forEach(([area, centrosDeArea]) => {
      if (!centrosDeArea || typeof centrosDeArea !== "object") return;
      Object.entries(centrosDeArea).forEach(([key, srvOrGroup]) => {
        if (srvOrGroup?.coordenadas) {
          lista.push({ area, key, coords: srvOrGroup.coordenadas });
        }
        // Aquí añadimos la comprobación de null
        else if (srvOrGroup && typeof srvOrGroup === "object") {
          Object.entries(srvOrGroup).forEach(([key2, srv]) => {
            if (srv?.coordenadas) {
              lista.push({ area, key: key2, coords: srv.coordenadas });
            }
          });
        }
      });
    });
    return lista;
  }, [estados.centros]);

  // siempre mostramos Chile a la derecha
  const available = Object.keys(estados.regiones || {});
  const hasPeru   = available.includes("peru");
  const hasFonchi = available.includes("fonchi");

  const chileRegions = available.filter(r => r !== "peru" && r !== "fonchi");
  const Regions = available

  const serviciosHabilitadosCentro = useMemo(() => {
    if (!centroSeleccionado || !serviciosCentro) return {};

    // Buscar en todas las áreas (Loslagos-Hornopiren, Loslagos-Puertomontt, etc.)
    for (const [areaKey, centrosDeArea] of Object.entries(serviciosCentro)) {
      for (const [centroKey, servicios] of Object.entries(centrosDeArea)) {
        if (centroKey.toLowerCase() === centroSeleccionado.toLowerCase()) {
          // Devuelve solo los servicios habilitados (status_service: true)
          const activos = Object.entries(servicios)
            .filter(([_, data]) => data?.status_service === true)
            .reduce((acc, [key, data]) => {
              acc[key] = data;
              return acc;
            }, {});
          return activos;
        }
      }
    }

    return {};
  }, [centroSeleccionado, serviciosCentro]);

  const {
    activeServices,
    disabledServices,
    centrosDisponiblesPorServicio,
  } = useMemo(() => {
    const active = new Set();
    const disabled = new Set();
    const centersByService = {};

    Object.entries(serviciosCentro || {}).forEach(([areaKey, centrosDeArea]) => {
      const [regionFromArea = "", areaFromKey = ""] = areaKey.split("-");

      Object.entries(centrosDeArea || {}).forEach(([centroKey, serviciosDelCentro]) => {
        const [centro = centroKey, areaFromCenter, regionFromCenter] = centroKey.split("-");
        const area = areaFromCenter || areaFromKey;
        const region = regionFromCenter || regionFromArea;

        Object.entries(serviciosDelCentro || {}).forEach(([serviceKey, serviceInfo]) => {
          if (serviceInfo?.status_service === true) {
            active.add(serviceKey);
            if (!centersByService[serviceKey]) centersByService[serviceKey] = {};
            if (!centersByService[serviceKey][region]) centersByService[serviceKey][region] = {};
            if (!centersByService[serviceKey][region][area]) centersByService[serviceKey][region][area] = [];
            const centerExists = centersByService[serviceKey][region][area]
              .some(existingCenter => existingCenter.toLowerCase() === centro.toLowerCase());
            if (!centerExists) {
              centersByService[serviceKey][region][area].push(centro);
            }
            return;
          }

          disabled.add(serviceKey);
        });
      });
    });

    active.forEach(serviceKey => disabled.delete(serviceKey));

    return {
      activeServices: Array.from(active),
      disabledServices: Array.from(disabled),
      centrosDisponiblesPorServicio: centersByService,
    };
  }, [serviciosCentro]);


  const handleServiceClick = async (service, info, centroKey = null) => {

    // 1) Si info es falso o status_service es false → alerta y corta ejecución
    if (!info) {
      setCentroSeleccionado(centroKey);
      setModalMessage(
        // aquí podrías usar una nueva clave de traducción 'service_not_selected_message'
        // o reutilizar 'service_inactive_message'
        translate('Por favor, seleccione un servicio para continuar.').replace('{value}', service)
      );
      setModalOpen(true);
      return;
    }
    if (info.status_service) {
      setServicioFiltrado(service);
      // console.log('servicio', service)
      const centers = centrosDisponiblesPorServicio[service];

      if (!centers || Object.keys(centers).length === 0) {
        setModalMessage(translate('centers_retrieval_error_message').replace('{value}', service));
        setModalOpen(true);
      } else {
        
        // console.log(`holaaaaaa /${capitalize(service)}`);
        localStorage.setItem('Regiones', JSON.stringify(centers));
        window.location.href = `/${capitalize(service)}`;
      }
    } else {
      setModalMessage(translate('service_inactive_message').replace('{value}', service));
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // console.log('estados',estados)
  // Lista de centro para dashboar de nanoox
  // useEffect(() => {
  // if (estados.centros && Object.keys(estados.centros).length > 0) {
  //   const listCenter = [];

  //   Object.entries(estados.centros).forEach(([areaKey, centros]) => {
  //     const [region, area] = areaKey.split("-"); // ej: "aysen-aysen"

  //     Object.keys(centros).forEach((centroKey) => {
  //       const [centro] = centroKey.split("-"); // ej: "puntacola-aysen-aysen"
  //       listCenter.push({ region, area, centro });
  //     });
  //   });

  //   // Guardar lista transformada en localStorage
  //   localStorage.setItem("listCenter", JSON.stringify(listCenter));
  // }
  // }, [estados]);
  // Lista de centros SOLO con el servicio nanoox activo
  useEffect(() => {
    if (
      estados.centros &&
      Object.keys(estados.centros).length > 0 &&
      serviciosCentro &&
      Object.keys(serviciosCentro).length > 0
    ) {
      const nanooxCenters = [];

      // Recorremos todas las áreas
      Object.entries(serviciosCentro).forEach(([areaKey, centros]) => {
        const [region, area] = areaKey.split("-");

        // Recorremos centros dentro del área
        Object.entries(centros).forEach(([centroKey, servicios]) => {
          const servicioNanoox = servicios?.nanoox;

          // Guardar solo si NANOX está activo
          if (servicioNanoox?.status_service === true) {
            const [centro] = centroKey.split("-");
            nanooxCenters.push({ region, area, centro });
          }
        });
      });

      console.log("Centros con NANOX activo:", nanooxCenters);

      localStorage.setItem("listCenter", JSON.stringify(nanooxCenters));
      window.dispatchEvent(new Event("nanoox-centers-updated"));
    }
  }, [estados, serviciosCentro]);



  useEffect(() => {
    const load = async () => setServiciosCentro(await fetchConsolidadoService(servidor));
    load(); const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, [servidor]);
console.log('serviio, ', serviciosCentro)
  useEffect(() => {
    fetch(CHILE_GEOJSON).then(r => r.json()).then(setChileGeo);
    fetch(PERU_GEOJSON).then(r => r.json()).then(setPeruGeo);
  }, []);

  // console.log('serviciosCentro',serviciosCentro)

  const PanelPrincipalProps = {
    SWVersion, translate, servicioFiltrado, setServicioFiltrado, cargo, serviceList, servidor, serviciosCentro, activeServices, disabledServices, centrosDisponiblesPorServicio
  }
  const ChileMapProps = {
    chileGeo, chileRegions, servicios,services:serviciosCentro, selRegion, setSelRegion, setSelArea, parseRegion, chileRegionMap, handleServiceClick, servicioFiltrado:servicioFiltrado
  }
  const PeruMapProps = {
    servicios,services:serviciosCentro, selRegion, setSelRegion, setSelArea, hasPeru, peruGeo , servicioFiltrado:servicioFiltrado, handleServiceClick
  }
  const PanelAreasProps = {
    Regions,capitalize, servicioFiltrado, handleServiceClick, serviciosCentro, selRegion, setSelRegion, selArea, setSelArea, estados
  }

  return (
    <div className="container-home">
      {/* Panel Principal, Selecciona servicios y redirige a vistas de configuraciones */}
      <PanelPrincipal {...PanelPrincipalProps}/>
      <main className={`home-layout ${servicioFiltrado ? 'with-panel' : 'map-only'}`}>
      {/* Mapas  */}
      <div className={`maps-wrapper ${(hasPeru || hasFonchi) ? '' : 'solo-chile'}`}>
        {(hasPeru || hasFonchi) && 
          <div className="special-wrapper">
            {hasPeru && (
              <div className={`map-container peru ${selRegion==="peru"?"selected":""}`}>
                <h3 className="map-title">{labelRegion("peru", "Perú")}</h3>
                <PeruMap {...PeruMapProps}/>
              </div>
            )}

            {hasFonchi && (
              <div className={`map-container fonchi ${selRegion==="fonchi"?"selected":""}`} onClick={() => { setSelRegion("fonchi"); setSelArea(null); }}>
                <h3 className="map-title-Fonchi">{labelRegion("fonchi", "Fonchi")}</h3>
                <div className="map">
                  <FonchiMap serviciosCentro={serviciosCentro} capitalize={capitalize} serviceIcons={serviceIcons} handleServiceClick={handleServiceClick} />
                </div>
              </div>
            )}
          </div>
        }
        <div className={`map-container chile ${selRegion==="chile"?"selected":""}`} onClick={() => { setSelRegion("chile"); setSelArea(null); }}>
          <h3 className="map-title">Chile</h3>
          <div className="map-frame chile-map-frame">
            <ChileMap {...ChileMapProps}/>
          </div>
        </div>
      </div>

     {/* <PanelAreas {...PanelAreasProps} /> */}
     {servicioFiltrado && <PanelAreas {...PanelAreasProps} />}
      </main>

      {/* <Modal open={modalOpen} onClose={handleCloseModal} style={{ ...style.modal }}>
            <div style={{ ...style.modalPaper }}>
              <Typography style={{ ...style.modalPaper.content }}>{modalMessage} </Typography>
              <Button style={{ ...style.modalPaper.button }} onClick={handleCloseModal} >
                {translate('accept_button')}
              </Button>
            </div>
      </Modal> */}

      <Modal
  open={modalOpen}
  onClose={handleCloseModal}
  disableEnforceFocus
  disableAutoFocus
  BackdropProps={{
    style: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
  }}
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      borderRadius: "2vh",
      textAlign: "center",
      backgroundColor: "#1d1e20",
      width: "30vw",
      height: "auto",
      padding: "3vh 1vw",
      zIndex: 10000,
      pointerEvents: "auto",
      position: "relative",
    }}
  >
    <Typography style={{ fontSize: "1.25vw", color: "#fff", marginBottom: "2vh" }}>
      {modalMessage}
    </Typography>

    {/* Solo renderizamos servicios habilitados */}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "1vw",
        pointerEvents: "auto",
      }}
    >
      {Object.entries(serviciosHabilitadosCentro).map(([serviceKey, datos]) => {
        const icon = serviceIcons[serviceKey];
        if (!icon) return null; // si no hay icono definido, lo ignoramos

        return (
          <div
            key={serviceKey}
            onClick={async () => {
              handleCloseModal();
              setServicioFiltrado(serviceKey);

              const centers = centrosDisponiblesPorServicio[serviceKey];

              if (!centers || Object.keys(centers).length === 0) {
                setModalMessage(
                  translate("centers_retrieval_error_message").replace("{value}", serviceKey)
                );
                setModalOpen(true);
                return;
              }

              localStorage.setItem("Regiones", JSON.stringify(centers));
              window.location.href = `/${capitalize(serviceKey)}`;
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#2a2a2a",
              borderRadius: "1vh",
              padding: "1vh 1vw",
              cursor: "pointer",
              transition: "all 0.2s ease",
              pointerEvents: "auto",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e84e0e")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#2a2a2a")
            }
          >
            <img
              src={icon}
              alt={serviceKey}
              style={{
                width: "3vw",
                height: "3vw",
                objectFit: "contain",
                marginBottom: "0.5vh",
              }}
            />
            <Typography
              variant="body2"
              style={{ color: "#fff", fontSize: "0.9vw" }}
            >
              {capitalize(serviceKey)}
            </Typography>
          </div>
        );
      })}
    </div>

    {/* Si no hay servicios habilitados */}
    {Object.keys(serviciosHabilitadosCentro).length === 0 && (
      <Typography
        variant="body2"
        style={{
          color: "#aaa",
          marginTop: "2vh",
          fontSize: "1vw",
        }}
      >
        No hay servicios habilitados para este centro.
      </Typography>
    )}

    <Button
      style={{
        fontSize: "1vw",
        backgroundColor: "#e84e0e",
        color: "#fff",
        height: "4vh",
        width: "6vw",
        marginTop: "3vh",
      }}
      onClick={handleCloseModal}
    >
      {translate("accept_button")}
    </Button>
  </div>
</Modal>


    



    </div>
  );
}


const style = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    pointerEvents: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.6)', // leve fondo
  },
  modalPaper: {
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection: 'column',
    borderRadius:'2vh',
    textAlign: 'center',
    backgroundColor:'#1d1e20',
    width: '30vw',
    height: '30vh',
    zIndex: 10000,
    pointerEvents: 'auto',
    padding: '2vh 1vw',
    position: 'relative',
    overflow: 'visible',
    img:{
        height: '10vh',
        marginTop:'5vh'
    },
    content:{
        fontSize:'1.25vw',
    },
    button:{
        fontSize:'1vw',
        backgroundColor:'#e84e0e',
        color:'#fff',
        height:'4vh',
        width:'6vw',
        marginTop:'2vh'

    },
    servicesContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '1vw',
      marginTop: '2vh',
    },
    serviceButton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#2a2a2a',
      borderRadius: '1vh',
      padding: '1vh 1vw',
      cursor: 'pointer',
      transition: 'transform 0.2s ease, background-color 0.2s ease',
    },
    serviceButtonHover: {
      backgroundColor: '#e84e0e',
      transform: 'scale(1.05)',
    },
    serviceIcon: {
      width: '3vw',
      height: '3vw',
      objectFit: 'contain',
      marginBottom: '0.5vh',
    },

  }
};
